import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom";
import classnames from 'classnames';
import autobind from 'autobind-decorator'

import { isDescendant } from "../../../utils/DomHelper"
import WindowEventHelper from "../../../lib/WindowEventHelper";
import If from "../../common/control/If";

class SkinListHeader extends Component {


	constructor(props, context) {
		super(props, context)

		this.state = {
			openFilterLayer: false,
			openSortLayer: false
		}
	}

	componentDidMount() {
		WindowEventHelper.add("click", this.handleWindowClick)
	}

	componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleWindowClick)
	}

	@autobind
	handleWindowClick(e) {
		const { sortLayerRoot, filterLayerRoot } = this.refs
		let target = e.target

		if (!isDescendant(sortLayerRoot, target)) {
            this.handleCloseSortLayer()
		}

		if (!isDescendant(filterLayerRoot, target)) {
            this.handleCloseFilterLayer()
		}
	}

	@autobind
	handleToggleOpenFilterLayer() {
		this.setState({
            openFilterLayer: !this.state.openFilterLayer
		})
	}

	@autobind
	handleToggleOpenSortLayer() {
		this.setState({
            openSortLayer: !this.state.openSortLayer
		});
	}

	@autobind
	handleCloseFilterLayer() {
		this.setState({
			openFilterLayer: false
		})
	}

	@autobind
	handleCloseSortLayer() {
		this.setState({
			openSortLayer: false
		})
	}
	
	@autobind
	handleChangeFilter(filter) {
		const { onChangeFilter } = this.props
		onChangeFilter(filter)
		this.handleCloseFilterLayer()
	}
	
	@autobind
	handleChangeSort(sort) {
		const { onChangeSort } = this.props
		onChangeSort(sort)
		this.handleCloseSortLayer()
	}

    render() {
		const { filter, sort } = this.props
		const { openFilterLayer, openSortLayer } = this.state
		
		return (<div ref="root" className="wrap_search">
					<p className="txt_search">블로그 스킨을 변경하거나 저장할 수 있고, 직접 업로드한 스킨을 적용할 수 있습니다.</p>
					<Link to="/design/skin/archive" className="link_storage">스킨 보관함<span className="ico_blog ico_arr" /></Link>
					<div ref="filterLayerRoot" className={classnames("opt_blog", {"opt_open":openFilterLayer})}>
						<button type="button" className="btn_opt" onClick={this.handleToggleOpenFilterLayer}>
							보기
							<span className="ico_blog ico_open" />
						</button>
						<div className="layer_opt">
							<ul className="list_opt">
								<li className={classnames({on:filter === 'all'})}>
									<label className="lab_btn">
										전체
										<input type="button" className="btn_g" value="전체"  onClick={() => this.handleChangeFilter('all')} />
									</label>
								</li>
								<li className={classnames({on:filter === 'responsive'})}>
									<label className="lab_btn">
										반응형
										<input type="button" className="btn_g" value="반응형" onClick={() => this.handleChangeFilter('responsive')} />
									</label>
								</li>
								<li className={classnames({on:filter === '1'})}>
									<label className="lab_btn">
										1단형
										<input type="button" className="btn_g" value="1단형" onClick={() => this.handleChangeFilter('1')} />
									</label>
								</li>
								<li className={classnames({on:filter === '2'})}>
									<label className="lab_btn">
										2단형
										<input type="button" className="btn_g" value="2단형" onClick={() => this.handleChangeFilter('2')} />
									</label>
								</li>
								<li className={classnames({on:filter === '3'})}>
									<label className="lab_btn">
										3단형
										<input type="button" className="btn_g" value="3단형" onClick={() => this.handleChangeFilter('3')} />
									</label>
								</li>
								<li className={classnames({on:filter === 'EDITABLE_MENU'})}>
									<label className="lab_btn">
										메뉴 지원
										<input type="button" className="btn_g" value="메뉴 지원" onClick={() => this.handleChangeFilter('EDITABLE_MENU')} />
									</label>
								</li>
								<li className={classnames({on:filter === 'SKIN_WIZARD'})}>
									<label className="lab_btn">
										스킨위자드 지원
										<input type="button" className="btn_g" value="스킨위자드 지원" onClick={() => this.handleChangeFilter('SKIN_WIZARD')} />
									</label>
								</li>
							</ul>
						</div>
					</div>
					<div ref="sortLayerRoot" className={classnames("opt_blog", {"opt_open":openSortLayer})}>
						<button type="button" className="btn_opt" onClick={this.handleToggleOpenSortLayer}>
							정렬
							<span className="ico_blog ico_open"></span>
						</button>
						<div className="layer_opt">
							<ul className="list_opt">
								<li className={classnames({on:sort === 'popular'})}>
									<label className="lab_btn">
										인기순
										<input type="button" className="btn_g" value="인기순" onClick={() => this.handleChangeSort('popular')} />
									</label>
								</li>
								<li className={classnames({on:sort === 'recent'})}>
									<label className="lab_btn">
										최신순
										<input type="button" className="btn_g" value="최신순" onClick={() => this.handleChangeSort('recent')} />
									</label>
								</li>
							</ul>
						</div>
					</div>
				</div>
		)
	}
}

SkinListHeader.propTypes = {
	filter: PropTypes.string,
	sort: PropTypes.string,
	open: PropTypes.bool,
	toggleOpen: PropTypes.func,
	onChangeFilter: PropTypes.func,
	onChangeSort: PropTypes.func,
}

export default SkinListHeader
